<template>
  <div class="container mt-3">
    <home-group
      v-for="item in cash.homeGroups"
      :key="item.id"
      :item="item"
      whole="home"
    />
  </div>
</template>

<script setup>
import { useCash } from "@/store/cash";
import HomeGroup from "../Group/HomeGroup.vue";
import { onMounted, onUnmounted } from "vue";
const cash = useCash();
let arrivalInterval;
onMounted(() => {
  cash.getHomeGroups();
  arrivalInterval = setInterval(() => {
    cash.getHomeGroups("home");
  }, 10000);
});
onUnmounted(() => {
  clearInterval(arrivalInterval);
});
</script>
<style scoped>
.title-text {
  font-size: 2em;
  font-weight: 600;
  letter-spacing: 2px;
  color: #000;
}

.jss117 {
  width: 100%;
  direction: ltr;
  margin-right: auto;
  margin-left: auto;
  padding-right: 15px;
  padding-left: 15px;
}
.jss110 {
  display: ruby;
  margin-right: -15px;
  margin-left: -15px;
}
.MuiGrid-container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
}
.jss132 {
  width: 200px;
  margin: 5px;
  display: inline-block;
  max-width: 200px;
}
.MuiCard-root {
  overflow: hidden;
}
.MuiPaper-elevation1 {
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
    0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
}
.MuiPaper-rounded {
  border-radius: 4px;
}
.MuiPaper-root {
  color: rgba(0, 0, 0, 0.87);
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  background-color: #fff;
}

.men-pro-item {
  position: relative;
  box-shadow: 0px 0px 15px 0px #d6d6d6;
  padding-bottom: 20px;
}

.men-thumb-item {
  position: relative;
}
.item-info-product {
  text-align: center;
  margin: 20px 0 0;
}
.info-product-price {
  margin: 10px 0;
}
.snipcart-details {
  text-align: center;
  margin: 0.5em auto 1em;
  width: 77%;
}
.snipcart-details {
  text-align: center;
  margin: 0.5em auto 1em;
  width: 77%;
}
.hvr-outline-out {
  display: flex;
  vertical-align: middle;
  transform: translateZ(0);
  box-shadow: 0 0 1px rgb(0 0 0 / 0%);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  background: #2fdab8;
}
.snipcart-details[data-v-fd72b6e8] {
  text-align: center;
  margin: 0.5em auto 1em;
  width: 77%;
}
.men-thumb-item .pro-image-front {
  opacity: 1;
  visibility: visible;
}
.men-thumb-item img {
  transition: all 0.5s ease-out 0s;
  padding: 52px 50px 20px;
}

.men-thumb-item .pro-image-front {
  opacity: 1;
  visibility: visible;
}
.men-thumb-item img {
  transition: all 0.5s ease-out 0s;
  padding: 52px 50px 20px;
}
.men-thumb-item img {
  transition: all 0.5s ease-out 0s;
}
.product-men img {
  width: 100%;
}
img {
  vertical-align: middle;
  border: 0;
  width: 100%;
}
.dir-rtl {
  direction: rtl;
  text-align: right;
}
.image-container {
  margin: auto;
}

.jss117 {
  width: 100%;
  direction: ltr;
  margin-right: auto;
  margin-left: auto;
  padding-right: 15px;
  padding-left: 15px;
}
.jss110 {
  display: ruby;
  margin-right: -15px;
  margin-left: -15px;
}
.MuiGrid-container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
}
.jss132 {
  width: 200px;
  margin: 5px;
  display: inline-block;
  max-width: 200px;
}
.MuiCard-root {
  overflow: hidden;
}
.MuiPaper-elevation1 {
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
    0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
}
.MuiPaper-rounded {
  border-radius: 4px;
}
.MuiPaper-root {
  color: rgba(0, 0, 0, 0.87);
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  background-color: #fff;
}

.men-pro-item {
  position: relative;
  box-shadow: 0px 0px 15px 0px #d6d6d6;
  padding-bottom: 20px;
}

.men-thumb-item {
  position: relative;
}
.item-info-product {
  text-align: center;
  margin: 20px 0 0;
}
.info-product-price {
  margin: 10px 0;
}
.snipcart-details {
  text-align: center;
  margin: 0.5em auto 1em;
  width: 77%;
}
.snipcart-details {
  text-align: center;
  margin: 0.5em auto 1em;
  width: 77%;
}
.hvr-outline-out {
  display: flex;
  vertical-align: middle;
  transform: translateZ(0);
  box-shadow: 0 0 1px rgb(0 0 0 / 0%);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  background: #2fdab8;
}
.snipcart-details[data-v-fd72b6e8] {
  text-align: center;
  margin: 0.5em auto 1em;
  width: 77%;
}
.men-thumb-item .pro-image-front {
  opacity: 1;
  visibility: visible;
}
.men-thumb-item img {
  transition: all 0.5s ease-out 0s;
  padding: 52px 50px 20px;
}

.men-thumb-item .pro-image-front {
  opacity: 1;
  visibility: visible;
}
.men-thumb-item img {
  transition: all 0.5s ease-out 0s;
  padding: 52px 50px 20px;
}
.men-thumb-item img {
  transition: all 0.5s ease-out 0s;
}
.product-men img {
  width: 100%;
}
img {
  vertical-align: middle;
  border: 0;
  width: 100%;
}
.dir-rtl {
  direction: rtl;
  text-align: right;
}
</style>
